import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import {
  GetExamBlockDto,
  GetLastEditorDto,
} from '../autogenerated/spdApiClient';

export interface ExamBlockContextInterface {
  block: (examId: string, reason: string) => Promise<GetExamBlockDto>;
  unblock: (examId: string) => Promise<void>;
  update: (examId: string, reason: string) => Promise<GetExamBlockDto>;
  getActive: (examId: string) => Promise<GetExamBlockDto | null>;
  getForExam: (examId: string) => Promise<GetExamBlockDto[]>;
  getLastEditor: (id: string) => Promise<GetLastEditorDto>;
}

export const ExamBlockContext = (
  api: DefaultApi,
): ExamBlockContextInterface => {
  return {
    block: (examId, reason) => api.examBlockControllerBlock(examId, { reason }),

    unblock: examId => api.examBlockControllerUnblock(examId),

    update: (examId, reason) =>
      api.examBlockControllerUpdate(examId, { reason }),

    getActive: examId =>
      api
        .examBlockControllerGetActive(examId)
        .then(res => res ?? null)
        .catch(() => null),

    getForExam: examId => api.examBlockControllerGetForExam(examId),

    getLastEditor: id => api.examBlockControllerGetLastEditor(id),
  };
};
